// @ts-nocheck
import 'react-image-gallery/styles/css/image-gallery.css';
import { NextPage } from 'next';
import Houses from '@/components/houses/Houses';
import { fetchProducts } from '@/components/houses/_helper/fetchData';
import { ProductItemTypes } from '@/components/houses/_types/productItem.types';
import { digitsFaToEn } from '@persian-tools/persian-tools';
import { getAuthHeaders } from '@/helpers/getServerSideCookies';
import { getUserAgent } from '@/helpers/userAgent';
import { checkIsWhiteLabel } from '@/helpers/checkEnvironments';
import { getClientIp } from '@/helpers/getClientIp';
type ProductProps = {
  data: ProductItemTypes;
  notFound?: boolean;
  mainUrl: string;
  host: string;
  offlineUnavailable?: boolean;
};
const Product: NextPage<ProductProps> = props => {
  if (props.offlineUnavailable) return null;
  return <Houses {...props} data-sentry-element="Houses" data-sentry-component="Product" data-sentry-source-file="[id].tsx" />;
};
export default Product;
export const getServerSideProps = async context => {
  const ua = getUserAgent(context.req);
  const ip = getClientIp(context.req);
  // FOR LONG TERM
  // const isWhiteLabel = checkIsWhiteLabel()
  const isMidterm = context.query?.mid_term;
  if (isMidterm) {
    const [pathname, queryString] = context.resolvedUrl.split('?');
    const params = new URLSearchParams(queryString);
    params.delete('mid_term');
    const newUrl = params.toString() ? `${pathname}?${params.toString()}` : pathname;
    return {
      redirect: {
        destination: newUrl,
        permanent: false
      }
    };
  }
  if (process.env.OFFLINE_MODE === 'true') {
    const {
      offlineHouseProps
    } = await import('@/helpers/offline/snapshot');
    const offlineResult = await offlineHouseProps(context);
    if (!offlineResult.props) return offlineResult;
    return {
      ...offlineResult,
      props: {
        ...offlineResult.props,
        ua
      }
    };
  }
  const mainUrl = context.req.url;
  const id = context.query.id || '';
  const searchId = context.query.search_id || '';
  const safarmarketIdQuery = context.query.safarmarketId || '';
  const host = 'https://' + context.req.headers.host;
  const {
    xsrfToken,
    cookieHeader,
    origin,
    safarmarketId
  } = getAuthHeaders(context.req.headers);
  const isFaAndEnDigits = /^[0-9\u06F0-\u06F9]+$/.test(id);
  if (isFaAndEnDigits) {
    const houseId = digitsFaToEn(id);
    const data = await fetchProducts({
      id: houseId,
      searchId,
      order_tracking: 1,
      cookieHeader,
      xsrfToken,
      origin,
      safarmarketId: safarmarketIdQuery || safarmarketId,
      req: context.req,
      clientIp: ip
    });
    if (data?.status as number === 404) {
      return {
        notFound: true
      };
    }
    return {
      props: {
        data: data?.data,
        mainUrl,
        host,
        ua
      }
    };
  } else {
    return {
      notFound: true
    };
  }
};